import styled from "styled-components";
import { Title } from "../Title/Title";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    max-width: 1216px;
  }
`

export const TabsList = styled.div`
  display: flex;
  position: relative;
  max-width: 100%;
  overflow-x: scroll;
  width: fit-content;
`

export const TabContainer = styled.div`
  cursor: pointer;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 32px;
  padding-right: 32px;
  width: fit-content;

  @media (max-width: 767px) {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const TabLabel = styled(Title)<{ isActive: boolean, color: string }>`
  text-align: center;
  border-color: transparent;
  border-bottom: ${({ isActive }) => (isActive && '3px solid transparent')};
  color: ${({ color }) => color};

  @media (max-width: 768px) {
    width: max-content;
    max-width: 350px;
  }
`

export const ContainerIndicator = styled.div<{ color: string }>`
  position: absolute;
  bottom: 0;
  border-bottom: 3px solid ${({ color }) => color || '#2539A1'};
`
